import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { SettingsPermissions } from "@redotech/redo-model/permissions";
import { RejectState } from "@redotech/redo-return-ui/flows/return-flow/reject";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const RejectDetails = memo(function RejectDetails({
  state,
  setState,
}: StepTypeDetailsProps<RejectState>) {
  const canEditReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        Message
      </Text>
      <RedoTextareaInputField
        placeholder="Enter rejection message..."
        readOnly={!canEditReturnsSettings}
        setValue={(message) => setState((state) => ({ ...state, message }))}
        value={state.message}
      />
      <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
        Message to show to the customer. Can include HTML.
      </Text>
    </Flex>
  );
});
